/**
 * 服务端ajax
 */
import requestBase from './requestBase';

let domain = `${location.protocol}//ms.jr.jd.com`;

switch (process.env.VUE_APP_ENV) {
  // case 'dev':
  case 'minner':
    domain = `${location.protocol}//msinner.jr.jd.com`;
    break;
  case 'dev':
    domain = location.origin;
    break;
  default:
    break;
}

$.extend($.config || ($.config = {}), {
  baseURL: `${domain}/gw/generic/syh_yxmx/h5/m/`
});

const timeUrl = `${domain}/gw/generic/bt/h5/m/`;
const sqUrl = `${location.protocol}//sq.jr.jd.com/cfContent/`;
// 注册接口
// 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=129777654
const REQUESTS = {
  // 首页信息
  recommendHomePage: {},
  // 猜你喜欢
  guessWhatYouLike: {},
  // 量身推荐
  personalRecommendation: {},
  // 获取广告位信息
  getBannerInfo: {},
  // 每日精选
  dailySelect: {},
  // 每日精选新接口
  dailySelectNew: {},
  // 每日精选最新接口
  dailySelectV3: {},
  // 获取首页活动列表
  getHomePageActivityList: {},
  // 获取收藏夹商品
  getFavoriteGoodsList: {},
  // 获取收藏夹活动
  getFavoriteActivityList: {},
  // 删除商品
  deleteGoods: {},
  // 删除活动
  deleteActivity: {},
  // 获取活动列表
  getActivityList: {},
  // 获取活动详情
  getActivityDetail: {},
  // 添加评论
  addComment: {},
  // 获取评论列表
  getCommentList: {},
  // 添加到收藏商品
  collectGoods: {},
  // 添加到购物车
  addCart: {},
  //收藏活动
  collectActivity: {},
  // 添加或删除活动
  addOrDelActivity: {},
  // 用户行为
  userBehaviorCollect: {},
  //专属免息
  exclusiveSku: {},
  //定时上下线
  contentConfigure: {
    baseURL: timeUrl
  },

  /**
   * 搜索和分类
   */
  // 一级类目搜索接口
  getFirstCateSearch: {},
  // 二级类目搜索接口
  getSecondCateSearch: {},
  // 三级类目搜索接口
  getThirdCateSearch: {},
  // 品牌类目搜索接口-筛选条件使用（要求先选择二级类目）
  getBrandCateBySecondCateSearch: {},
  //品牌类目搜索接口-筛选条件使用（要求先选择三级类目）
  getBrandCateByThirdCateSearch: {},
  // 子类目搜索接口
  getSubclassSearch: {},
  // 搜索SKU接口接口
  searchEnjoySku: {},
  // 搜索联想词接口
  searchAssociative: {},
  //获取地址接口
  getAddress: {},
  // 热搜词接口
  hotSearchAssociative: {},
  //获得全国所有省市接口
  getProvinces: {},
  //根据省id获取该省的所有市信息
  getCitys: {},
  //根据市id获取该市的所有县信息
  getCountys: {},
  //根据县id获取该县的所有镇信息
  getTowns: {},
  //首页聚焦接来客
  selectedActivity: {},
  //优享-免息提醒
  getFreeInterestCallList: {},
  //优享首页-悬浮窗接口
  suspension: {},
  //关闭首页广告弹框
  getSyXc: {},
  // 众筹转链
  getCpsLink: {
    baseURL: sqUrl
  }
};

$.each(REQUESTS, requestBase.register);

export default requestBase;
